/** 4.5 Section: d-s title, optional trailing caption, carved hairline with a cut terminal. */
import type { ReactElement, ReactNode } from "react";
export function Hairline({ terminal = true, className = "" }: { terminal?: boolean; className?: string }): ReactElement {
  return <div className={`hairline ${terminal ? "hairline--terminal" : ""} ${className}`} role="presentation" />;
}
export function Section({ title, trailing, children, className = "", id }: { title: string; trailing?: ReactNode; children?: ReactNode; className?: string; id?: string }): ReactElement {
  return (
    <section className={`section ${className}`} id={id} aria-label={title}>
      <div className="section__head">
        <h2 className="section__title">{title}</h2>
        {trailing !== undefined && <span className="section__trailing small">{trailing}</span>}
      </div>
      <Hairline />
      {children !== undefined && <div className="section__body">{children}</div>}
    </section>
  );
}
